declare global {
  interface Window {
    env: any;
  }
}

// change with your own variables
type EnvType = {
  REACT_APP_GATEWAY_URI: string;
  REACT_APP_PASS_URI: string;
  REACT_APP_SUPER_CAST_URI: string;
  REACT_APP_SENTRY_DSN: string;
  REACT_APP_SENTRY_SAMPLING_RATE: string;

  REACT_APP_PWA_ENABLED: string;
  REACT_APP_DEV_LOGGER: string;

  NODE_ENV: string;
  PUBLIC_URL: string;

  REACT_APP_COMELEC: string;
};
export const env: EnvType = { ...process.env, ...window.env };
